import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["width", "height"]
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M43 3.5C43 4.88071 41.8807 6 40.5 6C40.2689 6 40.0451 5.96863 39.8326 5.90992C39.4012 5.79073 39.0167 5.55882 38.7126 5.24788C38.2717 4.79713 38 4.1803 38 3.5C38 2.11929 39.1193 1 40.5 1C41.8807 1 43 2.11929 43 3.5ZM40.5 7C40.0675 7 39.6533 6.92154 39.2708 6.77808L38.6292 7.76977C38.4341 8.07117 38.0317 8.1574 37.7303 7.96238C37.4289 7.76736 37.3427 7.36494 37.5377 7.06355L38.1596 6.10245C37.4477 5.46179 37 4.53317 37 3.5C37 1.567 38.567 0 40.5 0C42.433 0 44 1.567 44 3.5C44 5.433 42.433 7 40.5 7ZM17 9.5C17 10.8807 15.8807 12 14.5 12C13.1193 12 12 10.8807 12 9.5C12 8.11929 13.1193 7 14.5 7C15.8807 7 17 8.11929 17 9.5ZM18 9.5C18 10.2227 17.781 10.8942 17.4057 11.4518L17.5263 11.6177L25.5258 22.6177L25.8479 23.0606C26.0592 23.0208 26.2772 23 26.5 23C26.7337 23 26.962 23.0229 27.1828 23.0666L27.4544 22.6469L28.3711 21.2302C28.5661 20.9288 28.9685 20.8426 29.2699 21.0376C29.5713 21.2326 29.6575 21.635 29.4625 21.9364L28.5458 23.3531L28.4084 23.5656C29.3666 24.19 30 25.271 30 26.5C30 28.433 28.433 30 26.5 30C24.567 30 23 28.433 23 26.5C23 25.2664 23.6382 24.1818 24.6026 23.5585L24.4744 23.3823L16.4787 12.3874C15.9158 12.7739 15.2343 13 14.5 13C13.7665 13 13.0856 12.7743 12.5231 12.3887L5.54838 23.349L5.40992 23.5666C6.36725 24.1911 7 25.2717 7 26.5C7 28.433 5.433 30 3.5 30C1.567 30 0 28.433 0 26.5C0 24.567 1.567 23 3.5 23C3.73503 23 3.96465 23.0232 4.1867 23.0673L4.45162 22.651L11.4516 11.651L11.5862 11.4396C11.2159 10.8844 11 10.2174 11 9.5C11 7.567 12.567 6 14.5 6C16.433 6 18 7.567 18 9.5ZM6 26.5C6 27.8807 4.88071 29 3.5 29C2.11929 29 1 27.8807 1 26.5C1 25.1193 2.11929 24 3.5 24C4.88071 24 6 25.1193 6 26.5ZM26.5 29C27.8807 29 29 27.8807 29 26.5C29 25.1193 27.8807 24 26.5 24C25.1193 24 24 25.1193 24 26.5C24 27.8807 25.1193 29 26.5 29ZM30.2044 18.3969C30.0094 18.6983 30.0956 19.1007 30.397 19.2957C30.6984 19.4907 31.1008 19.4045 31.2958 19.1031L33.1292 16.2698C33.3242 15.9684 33.238 15.566 32.9366 15.3709C32.6352 15.1759 32.2327 15.2622 32.0377 15.5635L30.2044 18.3969ZM33.8711 12.7302C33.676 13.0316 33.7623 13.434 34.0637 13.629C34.3651 13.8241 34.7675 13.7378 34.9625 13.4364L36.7958 10.6031C36.9908 10.3017 36.9046 9.89929 36.6032 9.70427C36.3018 9.50925 35.8994 9.59549 35.7044 9.89688L33.8711 12.7302Z",
  fill: "url(#paint0_linear_15939_63320)"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("defs", null, [
  /*#__PURE__*/_createElementVNode("linearGradient", {
    id: "paint0_linear_15939_63320",
    x1: "44",
    y1: "30",
    x2: "44",
    y2: "0",
    gradientUnits: "userSpaceOnUse"
  }, [
    /*#__PURE__*/_createElementVNode("stop", { "stop-color": "#00C6FB" }),
    /*#__PURE__*/_createElementVNode("stop", {
      offset: "1",
      "stop-color": "#005BEA"
    })
  ])
], -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

import { withDefaults } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'SawetLogo',
  props: {
    width: { default: 44 },
    height: { default: 30 }
  },
  setup(__props: any) {

const props = __props

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", {
    width: props.width,
    height: props.height,
    viewBox: "0 0 44 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, _hoisted_4, 8, _hoisted_1))
}
}

})